import { Union } from "../../fable_modules/fable-library-js.4.18.0/Types.js";
import { bool_type, class_type, int32_type, string_type, union_type, obj_type } from "../../fable_modules/fable-library-js.4.18.0/Reflection.js";
import { toProps } from "../React.fs.js";
import * as react from "react";
import { Typography, Layout as Layout_1 } from "antd";
import { map, toArray, defaultArg } from "../../fable_modules/fable-library-js.4.18.0/Option.js";
import { singleton, empty, isEmpty, cons, ofArray, tryPick } from "../../fable_modules/fable-library-js.4.18.0/List.js";

export class LayoutProps extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Style", "ClassName"];
    }
}

export function LayoutProps_$reflection() {
    return union_type("Loop54.Portal.WebUI.Interop.Antd.Layout.LayoutProps", [], LayoutProps, () => [[["Item", obj_type]], [["Item", obj_type]]]);
}

export function Layout(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(Layout_1, props_1, ...elems);
}

export function Header(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(Layout_1.Header, props_1, ...elems);
}

export function Content(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(Layout_1.Content, props_1, ...elems);
}

export class TitleProps extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ClassName", "Level"];
    }
}

export function TitleProps_$reflection() {
    return union_type("Loop54.Portal.WebUI.Interop.Antd.Layout.TitleProps", [], TitleProps, () => [[["Item", string_type]], [["Item", int32_type]]]);
}

export function Title(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(Typography.Title, props_1, ...elems);
}

export class PageHeaderProps extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Title", "Extra"];
    }
}

export function PageHeaderProps_$reflection() {
    return union_type("Loop54.Portal.WebUI.Interop.Antd.Layout.PageHeaderProps", [], PageHeaderProps, () => [[["Item", class_type("Fable.React.ReactElement")]], [["Item", class_type("Fable.React.ReactElement")]]]);
}

export function PageHeader(props, children) {
    const title = defaultArg(tryPick((_arg) => {
        if (_arg.tag === 0) {
            return _arg.fields[0];
        }
        else {
            return undefined;
        }
    }, props), "");
    const extra = ofArray(toArray(map((e) => react.createElement("div", {
        className: "portal-page-header-heading-extra",
    }, e), tryPick((_arg_1) => {
        if (_arg_1.tag === 1) {
            return _arg_1.fields[0];
        }
        else {
            return undefined;
        }
    }, props))));
    let heading;
    const children_5 = cons(react.createElement("div", {
        className: "portal-page-header-heading-title",
    }, title), extra);
    heading = react.createElement("div", {
        className: "portal-page-header-heading",
    }, ...children_5);
    const content = isEmpty(children) ? empty() : singleton(react.createElement("div", {
        className: "portal-page-header-content",
    }, ...children));
    return react.createElement("div", {
        className: "portal-page-header",
    }, ...cons(heading, content));
}

export class SiderProps extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Collapsible", "Theme", "Width", "Collapsed", "Trigger"];
    }
}

export function SiderProps_$reflection() {
    return union_type("Loop54.Portal.WebUI.Interop.Antd.Layout.SiderProps", [], SiderProps, () => [[["Item", bool_type]], [["Item", string_type]], [["Item", int32_type]], [["Item", bool_type]], [["Item", class_type("Fable.React.ReactElement")]]]);
}

export function Sider(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(Layout_1.Sider, props_1, ...elems);
}

